import React from 'react';
import SelectStyle from './styles';

const Select = ({ children, ...rest }) => {
  return (
    <SelectStyle {...rest}>
      {children}
    </SelectStyle>
  );
};

export default Select;
